import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { AnnouncementContentComponent } from './announcement-content/announcement-content.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CountdownV2Component } from '@fgb/portal-component-library/src/lib/shared/countdown-v2';
import { VideoPlayerComponent } from '@fgb/portal-component-library/src/lib/shared/video-player';
import { ExpandableCardComponent } from '@fgb/portal-component-library/src/lib/shared/expandable-card';

@NgModule({
  declarations: [AnnouncementsComponent, AnnouncementContentComponent],
  imports: [
    CommonModule,
    CarouselModule,
    LoadingModule,
    PipesModule,
    RouterModule,
    DirectivesModule,
    FGBSharedModule,
    CountdownV2Component,
    VideoPlayerComponent,
    ExpandableCardComponent,
  ],
  exports: [AnnouncementsComponent, AnnouncementContentComponent],
})
export class AnnouncementsModule {}
